import React, { FC } from 'react';
import {
  createStyles,
  IconButton,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import { useStaticQuery, graphql } from 'gatsby';
import { useTranslation } from '../../../../hooks/useTranslation';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

export const socialFollowLinksQuery = graphql`
  {
    socialButtons: allContentfulFooter {
      nodes {
        socialLinks {
          type
          url
        }
      }
    }
  }
`;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    socialBlock: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '12px',
      [theme.breakpoints.up('md')]: {
        width: 'auto',
      },
      [theme.breakpoints.down('md')]: {
        paddingBottom: '20px',
        justifyContent: 'center',
      },
    },
    header: {
      fontSize: '14px',
      fontWeight: 'bold',
      marginBottom: '10px',
      [theme.breakpoints.down('md')]: {
        marginTop: '30px',
        display: 'flex',
        justifyContent: 'center',
      },
    },
  }),
);

const SocialFollowLinks: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { socialButtons } = useStaticQuery(socialFollowLinksQuery);

  const generateSocialItem = (social: { type: string; url: string }) => {
    const renderIcon = (type: any) => {
      switch (type) {
        case 'facebook':
          return <FacebookIcon titleAccess={type} />;
        case 'instagram':
          return <InstagramIcon titleAccess={type} />;
        case 'linkedin':
          return <LinkedInIcon titleAccess={type} />;
      }
    };

    return (
      <IconButton
        color={'inherit'}
        size={'small'}
        href={social.url}
        target="_blank"
        key={social.type}
        css={{ position: 'static' }}
        aria-label={social.type}
      >
        {renderIcon(social.type)}
      </IconButton>
    );
  };

  const children: Array<JSX.Element> = [];

  socialButtons?.nodes[0]?.socialLinks.forEach(
    (node: { type: string; url: string }) => {
      children.push(generateSocialItem(node));
    },
  );

  return (
    <div>
      <Typography variant={'body1'} className={classes.header}>
        {t('FOLLOW_US')}
      </Typography>
      <div className={classes.socialBlock}>{children}</div>
    </div>
  );
};

export default SocialFollowLinks;
